import { useEffect } from "react";

const GA_ID = "G-EJRJYMNGBD";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * Loads Google Analytics (gtag.js) lazily after the page is interactive.
 * Keeps GA off the critical path so it does not eat main-thread time during LCP.
 */
export function Analytics() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (document.getElementById("ga4-loader")) return;

    const load = () => {
      const s = document.createElement("script");
      s.id = "ga4-loader";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      document.head.appendChild(s);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", GA_ID);
    };

    // Wait until the browser is idle, with a hard fallback after 4s.
    const w = window as Window & {
      requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
    };
    if (typeof w.requestIdleCallback === "function") {
      w.requestIdleCallback(load, { timeout: 4000 });
    } else {
      setTimeout(load, 2000);
    }
  }, []);

  return null;
}
